import React, { use } from 'react';

import HostedImage from 'src/components/common/hosted-image';
import { SiteContext } from 'src/context/site-context';
import { amplitudeBrandName, amplitudeTrackEvent } from 'src/helpers/amplitude-event-track';

import * as styles from './social-media-section.module.scss';

type SocialMediaSectionProps = {
  title: string | null;
  images: readonly Queries.FooterImage[];
  footerImageHeight: string[];
};

const SocialMediaSection = ({ title, images, footerImageHeight }: SocialMediaSectionProps) => {
  const { pageLevel } = use(SiteContext);
  const { buildType, language } = use(SiteContext);
  const handleClick = (name: string | null) => {
    void amplitudeTrackEvent(`Click to Footer Social Media`, {
      custom_page: window.location.origin,
      custom_level: pageLevel,
      brand: amplitudeBrandName(buildType),
      buildType,
      language,
      name,
      linkName: name,
      component: 'Footer Social Media',
    });
  };

  return (
    <div
      className={styles.section}
      style={
        {
          '--footer-image-height': footerImageHeight[0],
          '--footer-image-height-desktop': footerImageHeight[1],
        } as React.CSSProperties
      }
    >
      {title && <div className={styles.sectionTitle}>{title}</div>}
      <div className={styles.icons}>
        {images.map((image, index) => (
          <div key={`social-media-section-${index}`}>
            <a
              className={styles.imageLink}
              href={image.link}
              target={image.openInNewTab ? '_blank' : '_self'}
              rel="noopener noreferrer"
              onClick={() => handleClick(image.image.alternateText)}
            >
              <HostedImage imageDetails={image.image} loading="lazy" />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export { SocialMediaSection };
